import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  profileModal: boolean;
};

const initialState: InitialState = {
  profileModal: false,
};

const profileModalSlice = createSlice({
  name: "profileModalSlice",
  initialState,
  reducers: {
    toggleProfileModal: (state, action: PayloadAction) => {
      state.profileModal = !state.profileModal;
      return state;
    },
  },
});

export const { toggleProfileModal } = profileModalSlice.actions;
export default profileModalSlice;